import React, { useState, useRef, useEffect } from 'react';


import MobilePosition from './states/MobilePosition'


import usePositionsStore from "../../stores/PositionsStore";
import  useUserSettingStore from '../../stores/UserSettingsStore';
import useSettingsStore from '../../stores/SettingsStore';



import CreateTrade from './context_menu/CreateTrade';

function MobilePositions() {

  const positions = usePositionsStore((state) => state.positions);


  return (
    <div className="mobile_subcontainer">
      <div className="positions_container">

        {Object.keys(positions).map((exchange) => (
   
        <div className="positions_exchange_container" key={exchange}>
          <h3>{exchange.split('@')[1].toUpperCase()}</h3> 
          <li className="li">
            <div className="position_container">
            <div className="temoin"></div>
          <div className="div cell_instrument">Contracts</div>
          <div className=" cell position_qty">Qty</div>
          <div className="cell">Value</div>
          <div className="cell">Avg Price</div>
          <div className=" cell">Upnl</div>
            </div>
          
          </li>
        
          {Object.keys(positions[exchange]).map((coin) => {
            
            const position = positions[exchange][coin];
            const avgPrice = position.avgPrice
          
            const side = position.side;
            const coinName = coin.replace(/\d+$/, '');
            const coinNumber = coin.replace(coinName, '');
            let type = null;
            if (coinNumber === '0') {
              type = <span className="position_type">OW</span>;
            } else if (coinNumber === '1' || coinNumber === '2') {
              type = <span className="position_type">HM</span>;
            }
            const prefix = type
            const size = position.size;
      return (
        <MobilePosition avgPrice={avgPrice} coin={coin} position={position} size={size} exchange={exchange} side={side} coinName={coinName} coinNumber={coinNumber} prefix={prefix}/>

      );
      
    })}
  </div>
))}
</div>


    </div>
  )
}

export default MobilePositions

